import {
  Button,
  Grid,
  InputLabel,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomInput from "../../../../../../Components/CustomInput";
import FormControl from "@material-ui/core/FormControl";
import DataClient from "../../../../../../Service/general_data_service";

import "react-phone-input-2/lib/style.css";
import IconButton from "@material-ui/core/IconButton";
import Select from "@material-ui/core/Select/Select";
import DataService from "../../../../../../Service";
import CircularIndeterminate from "../../../../../../Components/Loader";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import AddIconBox from "@material-ui/icons/Add";
import ManageCoachingRequestForm from "../manage_coaching_request";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CopyToClipboard from "../../../../../../Components/copy_to_clipboard";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";

const useStyles = makeStyles(() => ({
  labelText: {},
}));

function CoachingRequestFormDetail(props) {
  const data = {
    first_name: "",
    middle_name: "",
    last_name: "",
    full_name: "",
    email: "",
    phone: "",
    source: "",
    initial_contact_date: "",
    contact_location: "",
    referred_by: "",
    sourced_for: "",
    associate_coach: "",
    associate_role: "",
    associate_bio: "",
    organisation_name: "",
    address_line1: "",
    address_line2: "",
    zipcode: "",
    city: "",
    country_list_id: "",
    general_internal_comment: "",
    access_level: "",
    facebook: "",
    linkedin: "",
    secondary_email: "",
    skype: "",
    suffix: "",
    twitter: "",
    service_authorisation: "",
    authorisation_provided_by: "",
    bame: "",
    diversity_inclusion: "",
    telephone: "",
    website: "",
    website1: "",
    visa_status: "",
    nationality_list_id: "",
    document: "",
    title: "",
    gender: "",
    gender_text: "",
    country: "",
  };

  const classes = useStyles();

  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [userData, setUserData] = useState(data);
  const dispatch = useDispatch();
  const [showCrfList, setShowCrfList] = useState(false);
  const [currentSelectionField, setCurrentSelectionField] = useState({});
  const [currentSelection, setCurrentSelection] = useState({});
  const [CoachinRates, setModuleSetups] = useState([]);
  const [crfId, setCrfId] = useState("");
  const [action, setAction] = useState(null);
  const [fieldAction, setFieldAction] = useState(null);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  const [crfSectionId, setCrfSectionId] = useState("");
  const [crfSlug, setCrfSlug] = useState("");
  const [radioValue, setValue] = useState("");
  const [crfDescription, setCrfDescription] = useState("");
  let history = useHistory();
  const movePreviousPage = () => {
    setShowCrfList(true);
  };

  const setInputState = (inputStateValue, inputId) => {
    if (inputId == "associate_coach") {
      inputStateValue = inputStateValue == "Yes" ? true : false;
    }
    setUserData({ ...userData, [inputId]: inputStateValue });
  };
  const handleUpdate = (radio) => {
    const statusData = {
      service_type: "External",
      approval_required: radio === "true" ? true : false,
    };

    DataClient.update(statusData, `/coaching_request_forms/${crfId}`).then(
      (res) => {
        if (res) {
          setLoading(true);
          dispatch(showSnackbar("success", ["Success!"]));
          CoachinRate();
          // handleClose();
          // CoachinRate();
        } else {
          setSubmitClickFlag(true);
          setLoading(false);
          // dispatch(showSnackbar("error", [["" + err.errors]]));
        }
      }
    );
  };
  const handleradioChange = (event) => {
    console.log(event.target.value, "from radio change");
    setValue(event.target.value);
    handleUpdate(event.target.value);
  };
  const CoachinRate = () => {
    const params = {
      programme_id: props.programme_id,
      id: crfSectionId || "",
    };
    DataService.getDirectData(`/coaching_request_forms`, params).then((res) => {
      setTotalCount(res["total_count"]);
      // if(res.success){
      //   if (res.coaching_request_form && res.coaching_request_form.length > 0) {
      let CoachinRate = res.coaching_request_form.crf_form_sections;
      let crfId = res.coaching_request_form.id;
      let crfStatus = res.coaching_request_form.approval_required;

      setValue(crfStatus ? "true" : "false");

      setCrfId(crfId);
      window.sessionStorage.setItem("slug", res.coaching_request_form.slug);
      setCrfSlug(res.coaching_request_form.slug);
      setCrfDescription(res.coaching_request_form.description);
      setModuleSetups(CoachinRate);
      setLoading(false);
    });
  };

  useEffect(() => {
    setLoading(true);
    CoachinRate();
    // setRefresh(!refresh)
  }, [crfSectionId, props.id]);
  const handleClose = (data, id) => {
    let moduleList = [];
    if (
      (action === "create" || fieldAction === "createField") &&
      data &&
      data.id
    ) {
      moduleList = [data].concat(modules);
      setModules(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter((base) => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setFieldAction(null);
    setCurrentSelection({});
    setCurrentSelectionField({});
  };

  return (
    <div>
      {
        // partnerDummyRoleArr.length > 0 &&
        <>
          {props.actionProgram === "editCrf" && (
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{
                padding: 30,
                marginBottom: 20,
                backgroundColor: "#F7F7F7",
              }}
            >
              <Grid item xs={12}>
                <CopyToClipboard
                  text={crfSlug}
                  formName={"coaching_request_form"}
                />
              </Grid>
              <Grid item xs={12}>
                <React.Fragment>
                  <React.Fragment>
                    {CoachinRates.length > 0 &&
                      CoachinRates.map((val, index) => {
                        return (
                          <div className={classes.categoryBox}>
                            <React.Fragment>
                              <React.Fragment>
                                {index === 0 && (
                                  <Button
                                    variant="contained"
                                    style={{
                                      fontSize: "13px",
                                      marginLeft: "80%",
                                      textTransform: "initial",
                                    }}
                                    color="primary"
                                    onClick={() => {
                                      setAction("create");
                                      setCrfSectionId(
                                        val.coaching_request_form_id
                                      );
                                    }}
                                    startIcon={
                                      <AddIconBox
                                        size="small"
                                        variant="outlined"
                                      />
                                    }
                                  >
                                    Add new section
                                  </Button>
                                )}
                              </React.Fragment>{" "}
                            </React.Fragment>
                          </div>
                        );
                      })}
                    <br /> <br />
                    {/* {crfDescription} */}
                  </React.Fragment>
                  <div className={classes.categoryBox}>
                    {CoachinRates.length > 0 &&
                      CoachinRates.map((val, index) => {
                        return (
                          <React.Fragment>
                            <Grid
                              container
                              direction="row"
                              alignItems="flex-start"
                              style={{
                                marginBottom: 20,
                                marginTop: 20,
                                backgroundColor: "#F2F2F2",
                              }}
                            >
                              <Grid item xs={10}>
                                <InputLabel>
                                  <Typography
                                    variant="subtitle1"
                                    color="secondary"
                                    style={{
                                      fontWeight: "bold",
                                      padding: "12px",
                                      // color: "#4D4F5C",
                                    }}
                                  >
                                    {val.section_name}
                                  </Typography>
                                </InputLabel>
                              </Grid>
                              <Grid item xs={2}>
                                {val.section_name !== "Description" && (
                                  <IconButton
                                    onClick={() => {
                                      setAction("edit");
                                      setCrfSectionId(
                                        val.coaching_request_form_id
                                      );
                                      setCurrentSelection(val);
                                    }}
                                    edge="start"
                                  >
                                    <EditIcon
                                      style={{
                                        fontSize: 25,
                                        marginTop: "-3px",
                                      }}
                                    />
                                  </IconButton>
                                )}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              </Grid>
                            </Grid>

                            {CoachinRates[index].crf_fields.map((row) => (
                              <Grid
                                container
                                direction="row"
                                alignItems="flex-start"
                                style={{ marginBottom: 20 }}
                              >
                                <Grid
                                  item
                                  xs={
                                    row.field_value === "Description"
                                      ? 10
                                      : row.field_type === "Text area"
                                      ? 12
                                      : 5
                                  }
                                >
                                  {row.active === true && (
                                    <InputLabel
                                      className={classes.labelText}
                                      style={{ marginTop: 20 }}
                                    >
                                      {/* {row.field_value === "Description" ? row.description  :row.field_value } */}
                                      <Typography
                                        variant="h2"
                                        style={{ color: "#000000" }}
                                      >
                                        {row.field_value === "Description"
                                          ? row.description
                                          : row.field_value ===
                                            "Is approval required"
                                          ? " "
                                          : row.field_value}
                                      </Typography>
                                    </InputLabel>
                                  )}
                                </Grid>
                                {row.active === true && (
                                  <Grid
                                    item
                                    style={{
                                      paddingTop:
                                        row.field_type === "Text area"
                                          ? "20px"
                                          : "",
                                    }}
                                    xs={
                                      row.field_value === "Description"
                                        ? 0
                                        : row.field_type === "Text area"
                                        ? 9
                                        : 4
                                    }
                                  >
                                    <Grid
                                      container
                                      direction="row"
                                      alignItems="center"
                                      style={{ marginBottom: 20 }}
                                    >
                                      <Grid item xs={12}>
                                        {row.field_type === "Text" &&
                                          row.field_value !== "Description" && (
                                            <CustomInput
                                              disabled
                                              id="first_name"
                                              variant="outlined"
                                              helperText={
                                                submitClickFlag &&
                                                userData.first_name == ""
                                                  ? "Please enter full name"
                                                  : ""
                                              }
                                              error={
                                                submitClickFlag &&
                                                userData.first_name == ""
                                                  ? true
                                                  : false
                                              }
                                              parentcall={setInputState}
                                              value={userData.first_name}
                                            />
                                          )}
                                        {row.field_type === "Text area" && (
                                          <CustomInput
                                            disabled
                                            multiline
                                            rows="4"
                                            id="first_name"
                                            variant="outlined"
                                            helperText={
                                              submitClickFlag &&
                                              userData.first_name == ""
                                                ? "Please enter full name"
                                                : ""
                                            }
                                            error={
                                              submitClickFlag &&
                                              userData.first_name == ""
                                                ? true
                                                : false
                                            }
                                            parentcall={setInputState}
                                            value={userData.first_name}
                                          />
                                        )}
                                        {(row.field_type === "dropdown" ||
                                          row.field_type === "Drop down") && (
                                          <Select
                                            helperText="Please select Location"
                                            variant="outlined"
                                            disabled
                                            style={{ width: "100%" }}
                                            inputProps={{
                                              id: "outlined-age-native-simple",
                                            }}
                                          ></Select>
                                        )}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                )}
                                <Grid
                                  item
                                  xs={row.field_value !== "Description" ? 1 : 0}
                                ></Grid>
                                {row.active === true && (
                                  <Grid
                                    item
                                    xs={
                                      row.field_value !== "Description" ? 2 : 2
                                    }
                                  >
                                    {
                                      <IconButton
                                        onClick={() => {
                                          setFieldAction("editField");
                                          setCrfSectionId(
                                            val.coaching_request_form_id
                                          );
                                          setCurrentSelection(val);
                                          setCurrentSelectionField(row);
                                        }}
                                      >
                                        <EditIcon
                                          style={{
                                            fontSize: 25,
                                            marginTop: "-3px",
                                          }}
                                        />
                                      </IconButton>
                                    }
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {row.field_value !== "Description" && (
                                      <IconButton
                                        onClick={() => {
                                          setFieldAction("deleteField");
                                          setCrfSectionId(
                                            val.coaching_request_form_id
                                          );
                                          setCurrentSelection(val);
                                          setCurrentSelectionField(row);
                                        }}
                                      >
                                        <CloseIcon
                                          style={{
                                            fontSize: 25,
                                            marginTop: "-3px",
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </Grid>
                                )}
                              </Grid>
                            ))}
                            {val.section_name !== "Description" && (
                              <Button
                                variant="contained"
                                style={{
                                  fontSize: "13px",
                                  marginLeft: "80%",
                                  marginBottom: "20px",
                                  textTransform: "initial",
                                }}
                                color="primary"
                                onClick={() => {
                                  setFieldAction("createField");
                                  setCrfSectionId(val.coaching_request_form_id);
                                  setCurrentSelection(val);
                                }}
                                startIcon={
                                  <AddIconBox size="small" variant="outlined" />
                                }
                              >
                                Add new field
                              </Button>
                            )}
                          </React.Fragment>
                        );
                      })}
                  </div>
                </React.Fragment>
              </Grid>
              <Grid item xs={12} >
                <InputLabel
                  className={classes.labelText}
                  style={{ marginTop: 30,marginLeft:"80%"}}
                  
                >
                  Is approval required
                </InputLabel>
              </Grid>
              <Grid item xs={12}  >
                <FormControl component="fieldset" >
                  <RadioGroup
                    row
                    aria-label="item"
                    value={radioValue}
                    name="approval_required"
                    onChange={handleradioChange}
                    style={{marginLeft:"80%"}}
                  >
                    <FormControlLabel
                      value={"true"}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={"false"}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {/* <Grid item xs={1}>
                <Button
                  variant="contained"
                  style={{ fontSize: "13px" }}
                  color="primary"
                  onClick={() => {
                    handleUpdate();
                  }}
                >
                  Save
                </Button>
              </Grid> */}
              {/* <Grid item xs={12}>      
              <InputLabel
                                      className={classes.labelText}
                                      style={{ marginTop: 20 }}
                                    >
                                      Is approval required

                                    </InputLabel></Grid>
              <FormControl component="fieldset">
        <Grid item xs={12}>      <RadioGroup row aria-label="item" value={radioValue === true ? "true" : "false"} onChange={(e)=>handleradioChange(e)} name="approval_required" >
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup></Grid>
                                </FormControl>
                                <Grid item xs={1}>
                                <Button
                                                     variant="contained"
                                                     style={{fontSize:'9px',}}
                                                     color="primary"
                                                     onClick={() => {
                                                      handleUpdate()
                                                     }}
                                                   >
                                                    Save
                                                   </Button></Grid> */}
            </Grid>
          )}

          {loading && <CircularIndeterminate />}
        </>
      }

      {(action || fieldAction) && (
        <ManageCoachingRequestForm
          action={action}
          fieldAction={fieldAction}
          crfSectionId={crfSectionId}
          data={currentSelection}
          data1={currentSelectionField}
          CoachinRate={CoachinRate}
          handleClose={handleClose}
        />
      )}
    </div>
  );
}

export default CoachingRequestFormDetail;
